import { render, staticRenderFns } from "./SkillsLevelsComparison.vue?vue&type=template&id=d333a2fa&scoped=true"
import script from "./SkillsLevelsComparison.vue?vue&type=script&lang=js"
export * from "./SkillsLevelsComparison.vue?vue&type=script&lang=js"
import style0 from "./SkillsLevelsComparison.vue?vue&type=style&index=0&id=d333a2fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d333a2fa",
  null
  
)

export default component.exports